const DefaultUser = [
    {
        "email": "admin@closedigit.com",
        "exp": 1727073736,
        "id": 1,
        "mobile": "1231231231",
        "name": "Admin",
        "refreshToken": "STATIC_TOKEN",
        "accessToken": "STATIC_TOKEN",
        "role": {
            "name": "admin",
            "permissions_role": [
                { "module_id": "1", "role_id": 3, "is_accessible": true, "feature_id": null },
                { "module_id": "2", "role_id": 3, "is_accessible": true, "feature_id": null },
                { "module_id": "3", "role_id": 3, "is_accessible": false, "feature_id": null },
                { "module_id": "4", "role_id": 3, "is_accessible": true, "feature_id": null },
                { "module_id": "5", "role_id": 3, "is_accessible": true, "feature_id": null },
                { "module_id": null, "role_id": 3, "is_accessible": true, "feature_id": "17" },
                { "module_id": null, "role_id": 3, "is_accessible": false, "feature_id": "18" },
                { "module_id": null, "role_id": 3, "is_accessible": true, "feature_id": "19" },
                { "module_id": null, "role_id": 3, "is_accessible": true, "feature_id": "20" },
                { "module_id": null, "role_id": 3, "is_accessible": true, "feature_id": "1" },
                { "module_id": null, "role_id": 3, "is_accessible": true, "feature_id": "22" },
                { "module_id": "7", "role_id": 3, "is_accessible": true, "feature_id": null },
                { "module_id": null, "role_id": 3, "is_accessible": true, "feature_id": "25" },
                { "module_id": null, "role_id": 3, "is_accessible": true, "feature_id": "26" },
                { "module_id": null, "role_id": 3, "is_accessible": true, "feature_id": "27" },
                { "module_id": null, "role_id": 3, "is_accessible": true, "feature_id": "28" },
            ]
        }
    },
    {
        "email": "hrsenior@closedigit.com",
        "exp": 1727073737,
        "id": 2,
        "mobile": "1231231232",
        "name": "Hrsenior",
        "refreshToken": "STATIC_TOKEN",
        "accessToken": "STATIC_TOKEN",
        "role": {
            "name": "hr_senior",
            "permissions_role": [
                { "module_id": "1", "role_id": 3, "is_accessible": true, "feature_id": null },
                { "module_id": "2", "role_id": 3, "is_accessible": true, "feature_id": null },
                { "module_id": "3", "role_id": 3, "is_accessible": false, "feature_id": null },
                { "module_id": "4", "role_id": 3, "is_accessible": true, "feature_id": null },
                { "module_id": "5", "role_id": 3, "is_accessible": true, "feature_id": null },
                { "module_id": null, "role_id": 3, "is_accessible": true, "feature_id": "17" },
                { "module_id": null, "role_id": 3, "is_accessible": false, "feature_id": "18" },
                { "module_id": null, "role_id": 3, "is_accessible": true, "feature_id": "19" },
                { "module_id": null, "role_id": 3, "is_accessible": true, "feature_id": "20" },
                { "module_id": null, "role_id": 3, "is_accessible": true, "feature_id": "1" },
                { "module_id": null, "role_id": 3, "is_accessible": true, "feature_id": "22" },
                { "module_id": "7", "role_id": 3, "is_accessible": true, "feature_id": null },
                { "module_id": null, "role_id": 3, "is_accessible": true, "feature_id": "25" },
                { "module_id": null, "role_id": 3, "is_accessible": true, "feature_id": "26" },
                { "module_id": null, "role_id": 3, "is_accessible": true, "feature_id": "27" },
                { "module_id": null, "role_id": 3, "is_accessible": true, "feature_id": "28" },
            ]
        }
    },
    {
        "email": "hrjunior@closedigit.com",
        "exp": 1727073738,
        "id": 3,
        "mobile": "1231231233",
        "name": "Hrjunior",
        "refreshToken": "STATIC_TOKEN",
        "accessToken": "STATIC_TOKEN",
        "name": "hr_junior",
        "permissions_role": [
            { "module_id": "1", "role_id": 3, "is_accessible": true, "feature_id": null },
            { "module_id": "2", "role_id": 3, "is_accessible": true, "feature_id": null },
            { "module_id": "3", "role_id": 3, "is_accessible": false, "feature_id": null },
            { "module_id": "4", "role_id": 3, "is_accessible": true, "feature_id": null },
            { "module_id": "5", "role_id": 3, "is_accessible": true, "feature_id": null },
            { "module_id": null, "role_id": 3, "is_accessible": true, "feature_id": "17" },
            { "module_id": null, "role_id": 3, "is_accessible": false, "feature_id": "18" },
            { "module_id": null, "role_id": 3, "is_accessible": true, "feature_id": "19" },
            { "module_id": null, "role_id": 3, "is_accessible": true, "feature_id": "20" },
            { "module_id": null, "role_id": 3, "is_accessible": true, "feature_id": "1" },
            { "module_id": null, "role_id": 3, "is_accessible": true, "feature_id": "22" },
            { "module_id": "7", "role_id": 3, "is_accessible": true, "feature_id": null },
            { "module_id": null, "role_id": 3, "is_accessible": true, "feature_id": "25" },
            { "module_id": null, "role_id": 3, "is_accessible": true, "feature_id": "26" },
            { "module_id": null, "role_id": 3, "is_accessible": true, "feature_id": "27" },
            { "module_id": null, "role_id": 3, "is_accessible": true, "feature_id": "28" },
        ]
    },
    {
        "email": "employee@closedigit.com",
        "exp": 1727073738,
        "id": 4,
        "mobile": "1231231233",
        "name": "Employee",
        "refreshToken": "STATIC_TOKEN",
        "accessToken": "STATIC_TOKEN",
        "name": "employee",
        "permissions_role": [
            { "module_id": "1", "role_id": 4, "is_accessible": true, "feature_id": null },
            { "module_id": "2", "role_id": 4, "is_accessible": true, "feature_id": null },
            { "module_id": "7", "role_id": 4, "is_accessible": true, "feature_id": null },
            // { "module_id": "4", "role_id": 3, "is_accessible": true, "feature_id": null },
            // { "module_id": "5", "role_id": 3, "is_accessible": true, "feature_id": null },
            // { "module_id": null, "role_id": 3, "is_accessible": true, "feature_id": "17" },
            // { "module_id": null, "role_id": 3, "is_accessible": false, "feature_id": "18" },
            // { "module_id": null, "role_id": 3, "is_accessible": true, "feature_id": "19" },
            // { "module_id": null, "role_id": 3, "is_accessible": true, "feature_id": "20" },
            // { "module_id": null, "role_id": 3, "is_accessible": true, "feature_id": "1" },
            // { "module_id": null, "role_id": 3, "is_accessible": true, "feature_id": "22" },
            // { "module_id": "7", "role_id": 3, "is_accessible": true, "feature_id": null },
            // { "module_id": null, "role_id": 3, "is_accessible": true, "feature_id": "25" },
            // { "module_id": null, "role_id": 3, "is_accessible": true, "feature_id": "26" },
            // { "module_id": null, "role_id": 3, "is_accessible": true, "feature_id": "27" },
            // { "module_id": null, "role_id": 3, "is_accessible": true, "feature_id": "28" },
        ]
    }
]


export default DefaultUser;